import { render, staticRenderFns } from "./OFSliderCurrency.vue?vue&type=template&id=10512cd8&scoped=true&"
import script from "./OFSliderCurrency.vue?vue&type=script&lang=js&"
export * from "./OFSliderCurrency.vue?vue&type=script&lang=js&"
import style0 from "./OFSliderCurrency.vue?vue&type=style&index=0&id=10512cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10512cd8",
  null
  
)

export default component.exports